import { useEffect, useState } from 'react';
import { AppContext } from './utils/AppContext';
import MyRoutes from './routes';

const MyApp = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [userInfo, setUserInfo] = useState({});

    const oldTime = localStorage.getItem('now');
    const currentTime = Date.now();
    const deltaS = currentTime - JSON.parse(oldTime);
    if (deltaS > 12000000) {
      localStorage.removeItem("session");
      localStorage.removeItem("sessionId");
      localStorage.removeItem("now");
    }
    
    useEffect(() => {
      let localData = localStorage.getItem("session");
      if (localData) {
        localData = JSON.parse(localData);
        let userData = {
          user_id: localData.name,
          user_role: localData.role,
          vr_app_session: localData.id
        }
        setUserInfo(userData);
      } 
    }, [])

    return (
        <AppContext.Provider value={{userInfo,setUserInfo, showMenu, setShowMenu}}>
          <MyRoutes />
        </AppContext.Provider>
    );
};

export default MyApp;